import { css } from "@emotion/css";
import { ArrayLayoutProps } from "@jsonforms/core";
import { withJsonFormsArrayLayoutProps } from "@jsonforms/react";
import { Fragment, useContext } from "react";

import { DeleteItemsOnQuestionControlNoSelectedHandler } from "./components/DeleteItemsOnQuestionControlNoSelectedHandler";
import { getPaths } from "./utils";
import { Item } from "./components/Item";
import { AddItemButton } from "./components/AddItemButton";
import { CustomAddSection } from "./components/CustomAddSection";
import { Divider } from "./components/Divider";
import { Wrapper } from "./components/Wrapper";
import { ItemCountProvider } from "./item-count-context";
import { CascadiaJsonFormContext } from "../../CascadiaJsonFormContext";
import { Summary } from "./components/Summary";

function ArrayLayout(props: ArrayLayoutProps) {
  const { isSummaryForPath } = useContext(CascadiaJsonFormContext);
  const isSummary = isSummaryForPath?.(props.path);
  const paths = getPaths(props.data, props.path);

  if (isSummary) {
    return <Summary {...props} />;
  }

  return (
    <>
      <DeleteItemsOnQuestionControlNoSelectedHandler {...props} />
      <ItemCountProvider>
        <div className={css(styles.layout)}>
          <CustomAddSection {...props} />
          <Wrapper {...props} paths={paths}>
            {({ path }, isOpen, index) => (
              <Fragment key={path}>
                <Divider {...props} index={index} />
                <Item
                  {...props}
                  isOpen={isOpen}
                  index={index}
                  path={path}
                  parentPath={props.path}
                />
              </Fragment>
            )}
          </Wrapper>
          <AddItemButton {...props} />
        </div>
      </ItemCountProvider>
    </>
  );
}

const styles = {
  layout: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-4)",
  }),
};

export const ArrayLayoutRenderer = withJsonFormsArrayLayoutProps(ArrayLayout);
